import { render, staticRenderFns } from "./m-pager.vue?vue&type=template&id=2ad1d03d"
import script from "./m-pager.vue?vue&type=script&lang=js"
export * from "./m-pager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports